module.exports = __webpack_public_path__ + "img/polis180-logo.56cfc79a.png";